import { useState } from "react";
import { toast } from "sonner";
import { useLanguage } from "@/context/LanguageContext";
import { publicApi } from "@/lib/api";

export default function InquiryForm({
  propertyId = null,
  service = null,
  compact = false,
  ctaLabel,
  testIdPrefix = "inquiry",
}) {
  const { t, lang } = useLanguage();
  const [form, setForm] = useState({ name: "", email: "", phone: "", message: "" });
  const [loading, setLoading] = useState(false);

  const update = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  async function onSubmit(e) {
    e.preventDefault();
    setLoading(true);
    try {
      await publicApi.createInquiry({
        ...form,
        property_id: propertyId,
        service: service,
        language: lang,
      });
      toast.success(t("contact.sent"));
      setForm({ name: "", email: "", phone: "", message: "" });
    } catch (err) {
      toast.error(t("contact.error"));
    } finally {
      setLoading(false);
    }
  }

  return (
    <form
      onSubmit={onSubmit}
      data-testid={`${testIdPrefix}-form`}
      className={compact ? "space-y-4" : "space-y-6"}
    >
      <div className={compact ? "grid grid-cols-1 gap-4" : "grid md:grid-cols-2 gap-6"}>
        <div>
          <label className="overline block mb-2">{t("contact.name")}</label>
          <input
            required
            value={form.name}
            onChange={update("name")}
            data-testid={`${testIdPrefix}-name`}
            className="w-full bg-transparent border-b border-line focus:border-ink outline-none py-2 text-ink"
          />
        </div>
        <div>
          <label className="overline block mb-2">{t("contact.email")}</label>
          <input
            required
            type="email"
            value={form.email}
            onChange={update("email")}
            data-testid={`${testIdPrefix}-email`}
            className="w-full bg-transparent border-b border-line focus:border-ink outline-none py-2 text-ink"
          />
        </div>
      </div>
      <div>
        <label className="overline block mb-2">{t("contact.phone")}</label>
        <input
          value={form.phone}
          onChange={update("phone")}
          data-testid={`${testIdPrefix}-phone`}
          className="w-full bg-transparent border-b border-line focus:border-ink outline-none py-2 text-ink"
        />
      </div>
      <div>
        <label className="overline block mb-2">{t("contact.message")}</label>
        <textarea
          required
          rows={compact ? 3 : 5}
          value={form.message}
          onChange={update("message")}
          data-testid={`${testIdPrefix}-message`}
          className="w-full bg-transparent border-b border-line focus:border-ink outline-none py-2 text-ink resize-none"
        />
      </div>
      <button
        type="submit"
        disabled={loading}
        data-testid={`${testIdPrefix}-submit`}
        className="px-8 py-3 bg-ink text-bg text-xs uppercase tracking-widest2 hover:bg-accent transition-colors disabled:opacity-60 btn-ghost"
      >
        {loading ? t("contact.sending") : ctaLabel || t("contact.send")}
      </button>
    </form>
  );
}
